import styled from 'styled-components';

import { LoginModalContainer } from '../../components/Login';

const StyledLoginWrapper = styled.div`
  display: flex;
  position: fixed;
  z-index: ${({ theme }) => theme.ZIndex.ZIndex.Elevated};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export function Login() {
  return (
    <StyledLoginWrapper data-testid="login-page">
      <LoginModalContainer flow="login" />
    </StyledLoginWrapper>
  );
}
